import { IString } from '../../../model/';
import { IAPIGameItem } from '../../../model/api-modules';

export const formatStudioList = (list: IAPIGameItem[]) => {
  const studios: IString<IAPIGameItem> = {};
  list.forEach((item) => {
    if (!studios[item.studioID]) {
      studios[item.studioID] = {
        ...item,
      };
    }
  });
  return Object.values(studios);
};
